var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('FormComponent',{attrs:{"prefillData":_vm.prefillData},on:{"created":_vm.refreshList,"clear-prefill":_vm.clearPrefill}}),_c('ListComponent',{attrs:{"reload":_vm.reloadList},on:{"copy-festival":_vm.onCopyFestival}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }